const defaultIns = {
  baoe: 0,
  baof: 0,
  duration: 0,
  period: 0,
  mode: 0,
  num: 0
}

export default class Insurance {
  constructor({baoe, baof, duration, period, mode, num} = defaultIns) {
    this.baoe = baoe
    this.baof = baof
    this.duration = duration
    this.period = period
    this.mode = mode
    this.num = num
  }
}